import { connect } from 'react-redux'
import * as actions from '../../actions/performance'
import Performance from '../../components/performance/Performance'

const mapStateToProps = ({ performance }) => ({
  isLoading: performance.isLoading,
  progressDetail: performance.progressDetail,
  course: performance.course,
})

const mapDispatchToProps = dispatch => ({
  fetchProgressDetail: (semesterId, courseId) => dispatch(actions.performance(semesterId, courseId)),
  fetchCourse: courseId => dispatch(actions.course(courseId)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Performance)
